var _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _path7, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 699,
    height: 701,
    viewBox: "0 0 699 701",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M412 491.865C391.592 486.096 368.582 482.852 344.239 482.852C320.498 482.852 298.027 485.938 278 491.441V533.428C298.027 527.924 320.498 524.839 344.239 524.839C368.582 524.839 391.592 528.083 412 533.852V491.865Z",
    fill: "#242E22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.403 484.877L274.403 296.146C273.644 296.126 272.882 296.116 272.118 296.116C226.064 296.116 188.729 333.451 188.729 379.505L188.729 535.152C188.729 539.877 189.122 544.511 189.877 549.022C211.317 523.443 240.225 501.529 274.403 484.877Z",
    fill: "url(#paint0_linear_2_148)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M403.715 488.735L403.715 300.005C404.474 299.985 405.236 299.974 406 299.974C452.055 299.974 489.39 337.309 489.39 383.364L489.39 539.01C489.39 543.736 488.997 548.369 488.241 552.88C466.801 527.302 437.893 505.388 403.715 488.735Z",
    fill: "url(#paint1_linear_2_148)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.996 303.392C249.644 336.168 243.751 373.703 241.274 413.821C239.371 444.652 239.652 474.316 241.807 501.762C252.643 494.407 264.349 487.714 276.806 481.771L274.719 302.288C273.995 302.26 273.269 302.242 272.54 302.233C267.567 302.176 262.706 302.575 257.996 303.392ZM445.019 419.595C447.533 453.213 447.508 485.372 445.311 514.731C431.667 504.335 416.516 494.983 400.121 486.87L398.034 307.387C398.757 307.376 399.483 307.375 400.211 307.384C410.017 307.497 419.429 309.377 428.139 312.717C436.225 344.762 442.135 381.036 445.019 419.595Z",
    fill: "#421116"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M271.958 517.639C299.989 509.128 331.762 505.131 365.205 506.887C382.948 507.818 400.054 510.311 416.235 514.148C434.845 471.335 444.383 401.267 439.433 322.995C433.456 228.489 408.048 148.743 376.881 115.686C368.027 104.283 357.927 97.6201 346.895 96.8058C300.838 93.4065 255.978 193.231 246.698 319.769C240.657 402.127 251.178 475.503 271.958 517.639Z",
    fill: "url(#paint2_linear_2_148)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M440.142 336.356C439.953 331.932 439.717 327.477 439.433 322.995C438.679 311.068 437.615 299.376 436.269 287.983C406.986 284.656 375.651 282.853 343.078 282.853C310.485 282.853 279.131 284.658 249.832 287.989C248.542 298.356 247.49 308.965 246.698 319.769C246.288 325.354 245.955 330.898 245.695 336.394C276.173 332.755 308.946 330.776 343.078 330.776C377.091 330.776 409.755 332.741 440.142 336.356ZM245.998 399.225C245.082 383.93 244.786 367.926 245.167 351.41C277.751 347.174 313.118 344.853 350.078 344.853C381.654 344.853 412.067 346.547 440.575 349.682C440.94 366.18 440.654 382.19 439.772 397.517C411.496 394.438 381.358 392.776 350.078 392.776C313.432 392.776 278.353 395.057 245.998 399.225Z",
    fill: "url(#paint3_radial_2_148)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 346.407,
    cy: 360.808,
    rx: 18,
    ry: 60.375,
    fill: "url(#paint4_linear_2_148)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M364.407 360.516C364.407 384.417 363.942 408.083 363.037 430.165C362.133 452.246 360.807 472.309 359.135 489.21C357.464 506.11 355.48 519.516 353.296 528.662C351.112 537.809 348.771 542.516 346.407 542.516C344.044 542.516 341.703 537.809 339.519 528.662C337.335 519.516 335.351 506.11 333.68 489.21C332.008 472.309 330.682 452.246 329.778 430.165C328.873 408.083 328.407 384.417 328.407 360.516L346.407 360.516H364.407Z",
    fill: "url(#paint5_linear_2_148)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_148)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 345,
    cy: 185.852,
    r: 51,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_2_148)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 345,
    cy: 185.852,
    r: 27,
    fill: "#6CCAD7"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_148",
    x: 290,
    y: 134.852,
    width: 110,
    height: 110,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_148"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_148",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_2_148",
    x: 318,
    y: 158.852,
    width: 54,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2_148"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_148",
    x1: 188.729,
    y1: 422.569,
    x2: 274.403,
    y2: 422.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC1C2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#931420"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_148",
    x1: 489.39,
    y1: 426.427,
    x2: 431.079,
    y2: 439.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC1B2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#931420"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_148",
    x1: 280.079,
    y1: 174.352,
    x2: 426.579,
    y2: 360.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA3329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5125,
    stopColor: "#BA1E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A01C23"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2_148",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(342.734 345.047) rotate(30.8294) scale(109.869 107.628)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408333,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.647916,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E3E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_148",
    x1: 296,
    y1: 343.221,
    x2: 306.596,
    y2: 395.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D84444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#960202"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_148",
    x1: 296,
    y1: 307.5,
    x2: 369,
    y2: 427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D84444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#960202"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.1ac62cf354fd7cd73edab2fb66ae3433.svg";
export { ForwardRef as ReactComponent };